import { GetLanguageAction } from "store/middlewares/general";
// import other actions as needed

export const checkAndUpdateTimestamps = (
  configData,
  apiTimestamps,
  setApiTimestamps,
  dispatch,
) => {
  if (!configData || typeof setApiTimestamps !== "function" || !dispatch) {
    return;
  }

  const now = Date.now();
  const currentTimestamps = apiTimestamps || {};
  const isFirstTime = Object.keys(currentTimestamps).length === 0;

  // ---------- First load ----------
  if (isFirstTime) {
    // Call every API that has a handler
    dispatch(GetLanguageAction());

    // Seed timestamps for all keys present in config
    const initial = {};
    Object.keys(configData).forEach((key) => {
      initial[key] = now;
    });
    setApiTimestamps(initial);
    return;
  }

  // ---------- Subsequent updates ----------
  const updatedKeys = [];

  for (const key of Object.keys(configData)) {
    const configTime = Number(configData[key]);
    // Guard against non-numeric values (should not happen for these keys)
    if (Number.isNaN(configTime)) continue;

    const localTime = Number(currentTimestamps[key]) || 0;

    if (configTime > localTime) {
      updatedKeys.push(key);
    }
  }

  if (updatedKeys.length === 0) return;

  // Dispatch only the changed APIs
  updatedKeys.forEach((key) => {
    switch (key) {
      case "language":
        dispatch(GetLanguageAction());
        break;
      // case "country":
      //   dispatch(GetCountryAction());
      //   break;
      // case "color":
      //   dispatch(GetColorAction());
      //   break;
      default:
        console.warn(`No matching API handler for config key: ${key}`);
        break;
    }
  });

  // Persist the new timestamps (only for the keys that changed)
  setApiTimestamps((prev) => {
    const next = { ...(prev || {}) };
    updatedKeys.forEach((key) => {
      next[key] = now;             
    });
    return next;
  });
};